export default "__VITE_ASSET__BLVh7qBo__"